import { render, staticRenderFns } from "./EditSchoolName.vue?vue&type=template&id=0b0bf51a&scoped=true&"
import script from "./EditSchoolName.vue?vue&type=script&lang=js&"
export * from "./EditSchoolName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0bf51a",
  null
  
)

export default component.exports